import { Salesman } from './Salesman';

export const SalesmanD2R = () => <Salesman />;
